<template>
    <div>
        <h1>OOPS, 404!</h1>
        <h2>{{$store.getters.visitID}} + 404</h2>
    </div>
</template>

<script>
export default {
    name: "Page404"
};
</script>

<style>
</style>